<template>
  <div v-title="$route.meta.title" :style="{ 'padding' : isBeforLogin ? '30px' : '0px'}">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="!isBeforLogin">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>修改密码</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               @submit.native.prevent="onSubmit()"
               label-width="150px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-alert style="margin-bottom: 25px"
                      v-if="$route.query['showDefaultPasswordHint']"
                      type="warning">
              请修改您的默认密码后进行其他操作
            </el-alert>
            <el-form-item label="请输入旧密码"
                          prop="oldPassword">
              <el-input type="password"
                        v-model="form.oldPassword"></el-input>
            </el-form-item>
            <el-form-item label="请输入新密码"
                          prop="newPassword">
              <el-input type="password"
                        v-model="form.newPassword"></el-input>
            </el-form-item>
            <el-form-item label="请重新输入新密码"
                          prop="newPasswordRpt">
              <el-input type="password"
                        v-model="form.newPasswordRpt"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button
            type="primary"
            size="mini"
            native-type="submit">保存
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../settins.rules.js'

export default {
  data () {
    return {
      formRules,
      form: {
        oldPassword: '',
        username: '',
        newPassword: '',
        newPasswordRpt: '',
        isBeforLogin: false,
      }
    }
  },
  computed: Vuex.mapState({
    user: state => state.login.user,
  }),
  created () {
    this.form.username = this.user.name
    this.isBeforLogin = this.$route.meta.isBeforLogin
  },
  beforeDestroy () {
    if (this.isBeforLogin) {
      this.$store.commit('LOGOUT')
      this.$router.push('/login')
    }
  },
  methods: {
    onSubmit () {
      if (!this.isStrongPwd(this.form.newPassword)) {
        this.$message.error('密码必须大于等于8位，且必须包含大小写字母、数字、特殊符号 4类内容')
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          request.common('changePassword', {
            'originPassword': this.form.oldPassword,
            'newPassword': this.form.newPassword,
            'newPassword_confirmation': this.form.newPasswordRpt,
          }).then((res) => {
            this.$alert(this.$route.meta.title + '成功，请重新登陆', '提示', {type: 'success'}).finally(() => {
              this.$store.commit('LOGOUT')
              this.$router.push(filter.loginPath('/'))
            })
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    isStrongPwd (pwd) {
      return pwd.length >= 8 && [/[\u0020-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]/, /[0-9]/, /[a-z]/, /[A-Z]/].map(regex =>
        regex.test(pwd)
      ).reduce((result, current) => {
        return result && current
      }, true)
    },
  }
}
</script>

<style>
#app {
  background-color: #eff0f4;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/pages/ChangePassword.vue